import styled from "styled-components"

export const StyledPublicSheetWidget = styled.iframe`
    border-radius: 4px;
    border: 1px solid #303d60;
    width: 100%;
    min-height: 800px;
    ${(props) => props.hasTitle && "margin-top: 10px;"}
`
